import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="cy-footer-outer">
      <div className="cy-footer">
        <div>
          <Link to="/" className="cy-logo" style={{ textDecoration: 'none', fontSize: '16px', marginBottom: '6px', display: 'inline-flex' }}>
            <span className="cy-logo-care">Care</span>
            <span className="cy-logo-yield">Yield</span>
          </Link>
          <p className="cy-footer-copy" style={{ marginTop: '6px' }}>
            Value-based care revenue intelligence by GeneWorks
          </p>
        </div>
        <nav className="cy-footer-links">
          <Link to="/" className="cy-footer-link">Home</Link>
          <Link to="/how-it-works" className="cy-footer-link">How it works</Link>
          <Link to="/whitepaper" className="cy-footer-link">Whitepaper</Link>
        </nav>
        <p className="cy-footer-copy">© 2025 GeneWorks, Inc.</p>
      </div>
    </footer>
  );
};

export default Footer;
